import type { DSIconName } from '@eiv2/design-system';

export interface NavLinkItem {
  label: string;
  path: string;
  icon: DSIconName;
}

export const NAV_LINKS: NavLinkItem[] = [
  { label: 'Visão geral', path: '/dashboard', icon: 'Graph' },
  { label: 'Funil', path: '/funnel', icon: 'Filter' },
  { label: 'Carrinhos', path: '/checkouts', icon: 'ShoppingCart' },
  { label: 'Eventos', path: '/events', icon: 'Ticket' },
  { label: 'Remarketing', path: '/remarketing', icon: 'Messages' }
];
